export default __webpack_public_path__ + "static/media/icons8-chat-96.add8c238.svg";